import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Colors } from '~/libs/mui/color'
import { toLocalMonthDate } from '~/libs/time'
import { VideoInfo } from '../../VideoInfo/VideoInfo'

interface VideoDetailContentProps {
  id: string
  title: string
  duration: string
  description: string
  creator: {
    name?: string
    avatar?: string
  }
  isUpComing: boolean
  willBePublishedAt: string
  willBeUnpublishedAt?: string | null
}

export const VideoDetailContent = ({
  id,
  title,
  duration,
  description,
  creator,
  isUpComing,
  willBePublishedAt,
  willBeUnpublishedAt,
}: VideoDetailContentProps) => {
  const { t } = useTranslation()

  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Typography id='video-preview-title' variant='h2' sx={{ color: Colors.yellow }}>
          {title}
        </Typography>
        {willBeUnpublishedAt && (
          <Typography variant='body1'>
            {toLocalMonthDate(willBeUnpublishedAt)} {t('ending_release')}
          </Typography>
        )}
        {isUpComing && (
          <Typography variant='body1'>
            {toLocalMonthDate(willBePublishedAt)} {t('upcoming_release')}
          </Typography>
        )}
      </Stack>
      <VideoInfo
        id={id}
        creator={{
          name: creator.name,
          avatarUrl: creator.avatar,
        }}
        duration={duration}
        description={description}
        showLike={!isUpComing}
      />
    </Stack>
  )
}
